module.exports = __webpack_public_path__ + "d4d2cd5cbba0e9bf946934b8187a2fcc.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/WW-ASI.svg
// module id = 5bMr
// module chunks = 0